import { ZButton, ZTypography } from "@atoms";
import { AnnouncementGoogleFormTemplateProps } from "./interface";
import {
	AnnouncementAction,
	AnnouncementActionType,
	AnnouncementGoogleFormTemplate as AnnouncementGoogleFormTemplateMetadata
} from "@/Contracts";
import { useHistory } from "react-router-dom";
import { EFontWeights } from "@atoms/ZTypography/interface";
import parse from "html-react-parser";

const AnnouncementGoogleFormTemplate: React.FC<
	AnnouncementGoogleFormTemplateProps
> = ({ announcement, remindLater, viewAnnouncement }) => {
	const history = useHistory();
	const metadata =
		announcement.template_metadata as AnnouncementGoogleFormTemplateMetadata;

	const getIframeHeight = () => {
		switch (announcement.modal_size) {
			case "sm":
				return 400;
			case "md":
				return 500;
			case "lg":
				return 700;
			default:
				return 600;
		}
	};

	const checkElement = (action: AnnouncementAction) => {
		return new Promise<HTMLElement>((resolve, reject) => {
			const interval = setInterval(() => {
				const element = document.querySelector(action.value);
				if (element) {
					clearInterval(interval);
					if (element instanceof HTMLElement) {
						resolve(element);
					} else {
						reject(new Error("Element is not an HTMLElement"));
					}
				}
			}, 100); // Check every 100ms

			setTimeout(() => {
				clearInterval(interval);
				reject(new Error("Element not found within 2 seconds"));
			}, 2000); // Maximum wait time of 2 seconds
		});
	};

	const onViewAnnouncement = async () => {
		viewAnnouncement();
		for (const action of metadata.action_button.actions) {
			if (action.type === AnnouncementActionType.Navigate) {
				history.push(action.value);
			} else if (action.type === AnnouncementActionType.Click) {
				try {
					const element = await checkElement(action);
					element.click();
				} catch (error) {
					console.error(error.message);
					break; // Break the loop if an error occurs
				}
			} else if (action.type === AnnouncementActionType.ExternalLink) {
				window.open(action.value, "_blank", "noopener,noreferrer");
			}
		}
	};

	return (
		<div>
			<ZTypography.ZTitle
				weight={EFontWeights.SEMIBOLD}
				level={5}
				className="mb-2"
			>
				{metadata.title}
			</ZTypography.ZTitle>
			<ZTypography.ZText className="mb-4 block">
				{parse(metadata.description)}
			</ZTypography.ZText>
			<iframe
				src={metadata.google_form_url}
				className="w-full border-none mb-4 block"
				style={{ height: `${getIframeHeight()}px`, maxHeight: "70vh" }}
			>
				Loading Google Form...
			</iframe>
			<div className="flex gap-4">
				{announcement.interactions_count === 0 && (
					<ZButton className="flex-1" onClick={remindLater}>
						Remind me later
					</ZButton>
				)}
				<ZButton
					type="primary"
					className="flex-1"
					onClick={onViewAnnouncement}
				>
					{metadata.action_button.label}
				</ZButton>
			</div>
		</div>
	);
};

export default AnnouncementGoogleFormTemplate;
